import React from 'react';
import { ButtonTertiary } from '@spotify-internal/encore-web';

import { useTranslation } from 'providers/translations/TranslationProvider';

import { StyledDialogAlert, StyledDialogHeader, StyledActions } from './styles';

interface IsHelpfulPollProps {
  onYesClick: () => void;
  onNoClick: () => void;
}

const IsHelpfulPoll = ({ onYesClick, onNoClick }: IsHelpfulPollProps) => {
  const { t } = useTranslation();

  return (
    <StyledDialogAlert
      id="is-helpfull-poll"
      data-testid="is-helpfull-poll"
      colorSet="announcement"
      dialogTitle={<StyledDialogHeader>{t('feedback_widget_was_this_helpful')}</StyledDialogHeader>}
      footer={
        <StyledActions>
          <ButtonTertiary buttonSize="sm" condensed onClick={onYesClick}>
            {t('yes')}
          </ButtonTertiary>
          <ButtonTertiary buttonSize="sm" condensed onClick={onNoClick}>
            {/* {t('no_more_help')}*/}
            No, I need more help
          </ButtonTertiary>
        </StyledActions>
      }
    />
  );
};

export default IsHelpfulPoll;
